export default __webpack_public_path__ + "static/recog-4-29d913d8de4d324ebaa4c5a56c2b1b1d.webp";